import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  recintos: [],
  fetchRecintosLoading: false,
  fetchRecintosError: null,

  recinto: {},
  fetchRecintoLoading: false,
  fetchRecintoError: null,

  addRecintoLoading: false,
  addRecintoError: null,

  updateRecintoLoading: false,
  updateRecintoError: null,

  portadaRecinto: {
    img: null,
    recintoId: null
  },
  fetchPortadaRecintoLoading: false,
  fetchPortadaRecintoError: null
};

export const recintosSlice = createSlice({
  name: 'RECINTOS',
  initialState,
  reducers: {
    resetRecinto: (state, action) => {
      state.recinto = action.payload;
    },

    fetchRecintosStart: state => {
      state.fetchRecintosLoading = true;
      state.fetchRecintosError = null;
    },
    fetchRecintosSuccess: (state, action) => {
      state.fetchRecintosLoading = false;
      state.recintos = action.payload;
    },
    fetchRecintosError: (state, action) => {
      state.fetchRecintosLoading = false;
      state.fetchRecintosError = action.payload;
    },

    fetchRecintoStart: state => {
      state.fetchRecintoLoading = true;
      state.fetchRecintoError = null;
    },
    fetchRecintoSuccess: (state, action) => {
      state.fetchRecintoLoading = false;
      state.recinto = action.payload;
    },
    fetchRecintoError: (state, action) => {
      state.fetchRecintoLoading = false;
      state.fetchRecintoError = action.payload;
    },

    addRecintoStart: state => {
      state.addRecintoLoading = true;
      state.addRecintoError = null;
    },
    addRecintoSuccess: (state, action) => {
      state.addRecintoLoading = false;
      state.recintos.unshift(action.payload);
    },
    addRecintoError: (state, action) => {
      state.addRecintoLoading = false;
      state.addRecintoError = action.payload;
    },

    updateRecintoStart: state => {
      state.updateRecintoLoading = true;
      state.updateRecintoError = null;
    },
    updateRecintoSuccess: (state, action) => {
      state.updateRecintoLoading = false;
      state.recinto = action.payload;
      const newArray = state.recintos.map(rec => {
        if (rec.id === action.payload.id) return action.payload;
        return rec;
      });
      state.recintos = newArray;
    },
    updateRecintoError: (state, action) => {
      state.updateRecintoLoading = false;
      state.updateRecintoError = action.payload;
    },

    updatePortadaRecintoStart: state => {
      state.updateRecintoLoading = true;
      state.updateRecintoError = null;
    },
    updatePortadaRecintoSuccess: (state, action) => {
      state.updateRecintoLoading = false;
      state.portadaRecinto = action.payload;
    },
    updatePortadaRecintoError: (state, action) => {
      state.updateRecintoLoading = false;
      state.updateRecintoError = action.payload;
    },

    fetchPortadaRecintoStart: state => {
      state.fetchPortadaRecintoLoading = true;
      state.fetchPortadaRecintoError = null;
    },
    fetchPortadaRecintoSuccess: (state, action) => {
      state.fetchPortadaRecintoLoading = false;
      state.portadaRecinto = action.payload;
    },
    fetchPortadaRecintoError: (state, action) => {
      state.fetchPortadaRecintoLoading = false;
      state.fetchPortadaRecintoError = action.payload;
    }
  }
});

export const {
  resetRecinto,
  fetchRecintosStart,
  fetchRecintosSuccess,
  fetchRecintosError,
  fetchRecintoStart,
  fetchRecintoSuccess,
  fetchRecintoError,
  addRecintoStart,
  addRecintoSuccess,
  addRecintoError,
  updateRecintoStart,
  updateRecintoSuccess,
  updateRecintoError,
  updatePortadaRecintoStart,
  updatePortadaRecintoSuccess,
  updatePortadaRecintoError,
  fetchPortadaRecintoStart,
  fetchPortadaRecintoSuccess,
  fetchPortadaRecintoError
} = recintosSlice.actions;

export default recintosSlice.reducer;
